export default function Pill({title}) {
  return (
    <div className="inline-block px-6 py-3 bg-primaryColor text-white text-md shadow-lg rounded-full">
      {title}
    </div>
  );
}